import styled, { css } from 'styled-components'

import { colors } from 'app/theme/colors'
import { breakpoint, mobile, space } from 'app/theme/tokens'

export const Page = styled.div`
  min-height: 100vh;
  background-color: ${colors.ohLightOrange};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 2vh 0vw 2vh 0vw;
  margin: 0 2.286vw;

  /* Mobile: stack the filter dropdowns vertically. The date picker and 3 user
     dropdowns need full width to be thumb-reachable on a 375px viewport. */
  ${breakpoint.down('tablet')} {
    flex-direction: column;
    align-items: stretch;
    gap: ${space.sm};
    margin: 0 ${space.md};
    padding: ${space.md} 0;
  }
`

export const RightHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;

  ${breakpoint.down('tablet')} {
    flex-direction: column;
    align-items: stretch;
    gap: ${space.sm};
    width: 100%;
  }
`

export const SubjectHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-bottom: 4vh;
  width: 100%;

  ${breakpoint.down('tablet')} {
    flex-direction: column;
    align-items: stretch;
    gap: ${space.sm};
    margin-bottom: ${space.md};
  }
`

export const PillContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  padding: 0vh 0vw 4vh 0vw;
  margin: 0 2.286vw;

  ${breakpoint.down('tablet')} {
    flex-direction: column;
    align-items: stretch;
    gap: ${space.sm};
    margin: 0 ${space.md};
    padding-bottom: ${space.md};
  }
`
export const pillStyles = {
  backgroundColor: colors.surfaceMuted,
  border: `1px solid ${colors.borderMuted}`,
  cursor: 'pointer'
}

export const selectedPillStyles = {
  backgroundColor: colors.ohLightOrange,
  border: `1px solid ${colors.ohOrangeBorder}`,
  fontWeight: '600',
  color: colors.ohOrange,
  cursor: 'pointer'
}

export const DropdownContainer = styled.div`
  width: 18.5vw;
  margin-right: 1vw;

  /* Mobile: full-width dropdowns; the 18.5vw rule collapses to ~70px on a
     phone which is too narrow for any autocomplete label. */
  ${breakpoint.down('tablet')} {
    width: 100%;
    margin-right: 0;
    min-height: ${mobile.tapTarget};
  }
`

export const TableContainer = styled.div`
  width: 95%;
  background-color: ${colors.white};
  margin: 0 2.286vw;
  padding-top: 2vh;

  ${breakpoint.down('tablet')} {
    width: auto;
    margin: 0 ${space.md};
    overflow-x: auto; /* horizontal scroll for wide attendance tables */
  }
`
export const TableSmallContainer = styled.div`
  width: max-content;
  background-color: ${colors.white};
  // margin: 0 2.286vw;
  padding-top: 2vh;
`

export const LoadingViewText = styled.span`
  font-size: 2.49vmin;
  font-family: AvenirDemi;
  margin-bottom: 40px;
  font-weight: 600;
`

export const Loader = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
`

export const ErrorModalTitle = styled.span`
  font-family: AvenirDemi;
  font-weight: 600;
`

export const Body = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 2.286vw;
  grid-gap: 2.67vh 1.6vw;
  gap: 2.67vh 1.6vw;
  padding-bottom: 2.67vh;
  transition: all 2s ease-in-out;
  -webkit-animation: fadeinout 2s ease-in-out forwards;
  animation: fadeinout 2s ease-in-out forwards;

  ${breakpoint.down('tablet')} {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin: 0 ${space.md};
    gap: ${space.md};
  }

  ${(props) =>
    props.nomargin &&
    css`
      margin: unset;
    `}

  @-webkit-keyframes fadeinout {
    100% {
      opacity: 1;
    }
    0% {
      opacity: 0;
    }
  }
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 2.67vh;
  gap: 3vh;
  transition: all 2s ease-in-out;
  -webkit-animation: fadeinout 2s ease-in-out forwards;
  animation: fadeinout 2s ease-in-out forwards;
`

export const TimelineRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1vw;
  width: 100%;

  ${breakpoint.down('tablet')} {
    flex-direction: column;
    gap: ${space.xs};
  }
`

export const TimeLabel = styled.div`
  min-width: 70px;
  background-color: transparent;
  font-family: AvenirDemi;
  font-size: 14px;
  color: ${colors.textSecondary};
  text-align: center;
  position: sticky;
  top: 20px;
  z-index: 1;
`

export const SchedulesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2.67vh 1.6vw;
  flex: 1;
  align-items: flex-start;

  ${breakpoint.down('tablet')} {
    flex-direction: column;
    align-items: stretch;
    gap: ${space.md};
    width: 100%;
  }
`

export const BottomPage = styled.div`
  margin-top: 25vh;
`

export const CardContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  box-shadow: 0.278vw 0.278vw 0.556vw rgb(0 0 0 / 25%);
  border-radius: 1.11vw;
  position: relative;
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 1.11vh 1.11vw;
  min-height: 2vh;

  background: ${colors.ohOrange};
  border-radius: 1.11vw 1.11vw 0px 0px;
  color: ${colors.white};
  width: 16.5vw;

  /* Mobile: full width + larger padding so the header tap area is at least
     44pt. Border radius switches to flat pixel values (vw clipped to ~3px
     on a 375px screen, which looks like no radius at all). */
  ${breakpoint.down('tablet')} {
    width: 100%;
    padding: ${space.sm} ${space.md};
    border-radius: 8px 8px 0 0;
    min-height: ${mobile.tapTarget};
  }

  ${(props) =>
    props.batchTypeColor &&
    css`
      background: ${props.batchTypeColor};
    `}
`

export const Room = styled.div``

export const CardBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  padding: 1.78vh 1.11vw;
  background: ${colors.white};
  border-radius: 0px 0px 1.11vw 1.11vw;
  width: 16.5vw;
  grid-gap: 1vh;

  ${breakpoint.down('tablet')} {
    width: 100%;
    padding: ${space.md};
    border-radius: 0 0 8px 8px;
    gap: ${space.sm};
  }
`

export const SubjectCardBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  padding: 1.11vh 1.11vw;
  height: 22vh;
  background: ${colors.white};
  border-radius: 1.11vw;
  width: 16.5vw;

  ${breakpoint.down('tablet')} {
    width: 100%;
    height: auto;
    padding: ${space.md};
    border-radius: 8px;
  }
`

export const Info = styled.div`
  display: flex;
  flex: 0.8;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  grid-gap: 0.44vh;
  max-width: 15vw;

  ${breakpoint.down('tablet')} {
    max-width: 100%;
    flex: 1 1 auto;
    gap: ${space.xs};
  }
`

export const Attendance = styled.div`
  display: flex;
  flex: 0.2;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`

export const ChildCards = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  grid-gap: 2vh;
  width: 100%;
`

export const Time = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.11vw;
  margin-right: 0.5vw;
`

export const Image = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 16vh;
  width: 13vw;

  /* Mobile: this is a decorative image — 16vh = ~107px on a phone, which
     pushes the card vertically by 100px for no information gain. Cap it
     so the card is sized by content, not decoration. */
  ${breakpoint.down('tablet')} {
    height: 56px;
    width: 56px;
    opacity: 0.6;
  }
`

export const SubjectImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 15vw;

  ${breakpoint.down('tablet')} {
    width: 48px;
    opacity: 0.6;
  }
`

/* Typography note: desktop uses vmin so headings scale with the window,
   which works at 1920×1080. On a 375×667 phone, vmin = 3.75px and these
   font sizes collapse to 5–9px — unreadable. Mobile overrides below pin
   each to a real px value that meets 14px+ minimum for readable copy
   (16px for primary, 13–14px for secondary). */

export const Today = styled.span`
  font-size: 2.48vmin;
  font-family: AvenirDemi;
  font-weight: 600;

  ${breakpoint.down('tablet')} {
    font-size: 16px;
  }
`

export const Boldheading = styled.span`
  flex: 0.2;
  font-size: 2.2vmin;
  font-family: AvenirDemi;
  font-weight: 600;
  text-transform: lowercase;
  color: ${colors.ohRed};

  ${breakpoint.down('tablet')} {
    font-size: 16px;
    flex: 0 0 auto;
  }
`

export const Mediumheading = styled.span`
  font-size: 1.7vmin;
  font-family: Avenir;
  font-weight: 600;
  text-transform: lowercase;
  white-space: nowrap;

  ${breakpoint.down('tablet')} {
    font-size: 14px;
  }
`

export const Regularheading = styled.span`
  font-size: 1.5vmin;
  font-family: Avenir;
  font-weight: 600;
  color: ${colors.textTertiary};
  align-self: end;

  ${breakpoint.down('tablet')} {
    font-size: 13px;
  }
`

export const Subtitle = styled.span`
  font-size: 1.33vmin;
  font-family: Avenir;
  font-style: italic;
  font-weight: 600;

  ${breakpoint.down('tablet')} {
    font-size: 12px;
  }
`

export const Name = styled.span`
  font-size: 2.25vmin;
  font-family: AvenirDemi;
  font-weight: 600;
  text-transform: lowercase;
  ${(props) =>
    css`
      color: ${props.color};
    `}

  ${breakpoint.down('tablet')} {
    font-size: 16px;
  }
`

export const Subheading = styled.span`
  font-size: 1.56vmin;
  font-family: Avenir;

  ${breakpoint.down('tablet')} {
    font-size: 13px;
  }
`

export const Boldtext = styled.span`
  font-size: 1.5vmin;
  font-family: AvenirDemi;
  font-weight: 600;
  white-space: nowrap;

  ${breakpoint.down('tablet')} {
    font-size: 14px;
  }
`

export const Container = styled.div`
  width: 100%;
  min-width: 200px;

  input.custom-date-picker-input {
    height: 40px;
    font-size: 16px;
    padding: 18.5px 14px;
    background: transparent;
    border-color: ${colors.textTertiary};

    &:hover {
      border-color: ${colors.borderHover};
    }

    &:focus-visible {
      outline-color: ${colors.ohOrange};
    }
  }
`
